<template>
  <div class="header" :class="{ inside: showBack }">
    <div class="selects">
        <span class="cc" @click="toggleLanguage"><a href="javascript:" @click="navigateToAntherLanguage">中文</a></span>
        <ul v-show="languageVisible">
          <li class="" style="text-align: center; cursor: text;" @click="navigateToEnglish">EN</li>
        </ul>
      </div>
    <div class="logo">
      <a class="inside" href="javascript: void(0)" v-if="showBack">
        <img class="icon-back" src="../../assets/images/nicon-search-back.png" alt="" @click="goBack" />
        <img src="../../assets/images/nlogo.png" alt="" @click="goHome" />
      </a>
      <a href="/" v-else>
        <img src="../../assets/images/nlogo.png" alt="" />
      </a>
    </div>
    <!-- <div class="language">
      <div class="search-type" @click="setLanguageVisible">
        <p>{{ ['CN', 'EN'][this.index] }}</p>
        <img src="../../assets/images/nicon-arrow-down2.png" />
      </div>
      <div class="search-type-list" v-show="languageVisible">
        <p :class="{ active: index == 0 }" @click="selectLanguage(0)">
          <span></span> CN
        </p>
        <p :class="{ active: index == 1 }" @click="selectLanguage(1)">
          <span></span> EN
        </p>
      </div>
    </div> -->
    <!-- <div class="mask" v-show="languageVisible" @click="closeAllPopup"></div> -->
  </div>
</template>

<script>
  import config from "../../common/config"
  export default {
    props: ["showBack", "callback"],
    data() {
      return {
        languageVisible: false,
        index: 0,
        config
      }
    },
    methods: {
      setLanguageVisible() {
        this.languageVisible = !this.languageVisible
      },
      selectLanguage(index) {
        this.index = index
        this.languageVisible = false
        if (index === 0) {
          window.location.href = YLKAPI + '/#/'
        }
      },
      closeAllPopup() {
        this.languageVisible = false
      },
      // 返回上一页
      goBack() {
        window.history.back()
      },
      // 返回首页
      goHome() {
        window.location.href = "/"
      },
      toggleLanguage() {
        this.languageVisible = !this.languageVisible
      },
      navigateToEnglish() {
        window.location.reload()
      },
      navigateToAntherLanguage() {
        window.location.href = window.location.href.replace(/(\.)?(-)?en/, '')
      }
    }
  }
</script>

<style lang="less" scoped="scoped">
  .header {
    display: flex;
    align-items: center;
    padding: 2.4rem 2.4rem 2.1rem 2.4rem;

    &.inside {
      padding: 2.4rem 2.4rem 4.2rem 2.4rem;
    }

    .logo {
      flex: 1;

      img {
        display: block;
        width: 8rem;
      }

      .inside {
        display: flex;
        align-items: center;

        img {
          display: block;
          width: 6rem;
        }

        .icon-back {
          width: 0.8rem;
          margin-right: 2rem;
        }
      }
    }
  }

  .language {
    position: relative;
  }

  .search-type {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
    color: #999;

    img {
      display: block;
      width: 1rem;
      margin-left: .5rem;
    }
  }

  .search-type-list {
    position: absolute;
    top: 3rem;
    right: -2rem;
    background-color: #eaedf6;
    border-radius: 5px;
    box-shadow: 0 0 5px rgba(0, 0, 0, .8);
    padding: 1rem 1.5rem;
    z-index: 10;

    &:before {
      content: '';
      border-top: 8px transparent dashed;
      border-left: 6px transparent dashed;
      border-bottom: 8px #eaedf6 solid;
      border-right: 6px transparent dashed;
      position: absolute;
      top: -1.6rem;
      left: 50%;
      margin-left: -5px;
    }

    p {
      font-size: 1.4rem;
      border-bottom: 1px solid #ddd;
      padding: 1rem 0;
      color: #666;
      width: 60px;

      &:last-child {
        border-bottom: 0;
        border-top: 1px solid #fff;
      }

      &.active {
        span {
          border-color: #597eff;

          &:before {
            content: '';
            display: block;
            position: absolute;
            top: 50%;
            left: 50%;
            width: .8rem;
            height: .8rem;
            margin: -.4rem 0 0 -.4rem;
            border-radius: 50%;
            background-color: #597eff;
          }
        }
      }

      span {
        position: relative;
        border: 1px solid #aaa;
        border-radius: 50%;
        display: inline-block;
        vertical-align: middle;
        width: 1.4rem;
        height: 1.4rem;
        margin-right: .5rem;
      }
    }
  }

  .mask {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
  }

   .selects {
      width: 60px;
      border-radius: 5px;
      margin-top: 10px;
      margin-right: 2.4rem;
      position: absolute;
      top: 0;
      right: 0;
      background-position: right -52px;
      height: 20px;
      cursor: pointer;
      background: url(https://zt.ibuychem.com/cms/en/arr.png) 52px 8px no-repeat;
  }

  .selects:hover {
      background-position: 52px -31px;
  }

  .selects span {
      display: block;
      cursor: pointer;
      padding-left: 22px;
      background: url(https://zt.ibuychem.com/crossborder/images/img_14.png) no-repeat 0 center;
      background-size: 14px 14px;
      font-style: normal;
      border-radius: 5px;
      font-size: 12px;
      position: relative;
  }

  .selects span a {
      color: #fff;
  }

  .selects ul {
      overflow-y: auto;
      background: #fff;
      border: 1px solid #e1e1e1;
      border-top: 0;
      position: absolute;
      right: 0;
      width: 100%;
      top: 20px;
  }

  .selects ul li {
      cursor: pointer;
      height: 24px;
      line-height: 24px;
      color: #666;
      padding-left: 0 !important;
      display: block;
      float: none !important;
  }

  .selects ul li a {
      color: #666;
      display: block;
      text-align: center;
      margin-left: 0 !important;
      margin-right: 0 !important;
  }

  .selects ul li a img {
      display: inline-block;
      vertical-align: middle;
      width: 14px;
      margin-right: 4px;
      margin-top: -1px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/header.vue